import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { withAppContext } from '../contexts/app';

import Button from 'shared/Button';
import Modal from 'shared/Modal';

class DisclaimerModal extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // For dev purposes: in case we want the user-readable link to match the current server (eg: localhost, staging, etc).
    // const termsUrl = `${this.props.app.baseUrl.replace(/(^\w+:|^)\/\//, '')}/terms`;

    return (
      <Modal className="disclaimer-modal" headerText="Disclaimer" onModalClose={this.props.onModalClosed}>
        <div className="disclaimer-modal__intro">
          Before creating your account, you must accept the following as well as our <Link to="/terms" target="_blank">Terms of Service</Link> and <Link to="/terms#privacy_policy" target="_blank">Privacy Policy</Link>:
        </div>

        <div className="disclaimer-modal__content">
          <ul>
            <li>The Triage App is a screening application for skin diseases and conditions that has not been approved by Health Canada or by the U.S. Food and Drug Administration.</li>
            <li>The Triage App, including its dermoscopic capabilities, is intended For Investigative Use Only by healthcare professionals and investigators as a clinical decision support tool to assist in the identification of skin diseases and conditions. The accuracy and performance characteristics of the Triage App have not been established.</li>
            <li>The Triage App is not intended for use by individuals except under the direction of their physician or other qualified healthcare professional. Individuals should always seek the advice of a physician or other qualified healthcare professional with any questions they may have regarding medical conditions or symptoms.</li>
            <li>The Triage App, including its dermoscopic capabilities, is not intended to definitively diagnose or direct the treatment of medical condition or disease (including, without limitation, skin conditions or diseases), and it is not intended to be used as the sole or primary basis for a diagnosis.</li>
            <li>Individuals should never disregard professional medical advice or delay in seeking it because of something they may have heard or read about the Triage App. Reliance on any information provided by the Triage App including, without limitation, information provided by Triage, Triage employees, or other representatives of Triage appearing on the App, is solely at any user’s own risk. If an individual believes they may have a medical emergency, he or she should call their physician or 911 immediately.</li>
          </ul>
        </div>

        <div className="disclaimer-modal__buttons">
          <Button className="disclaimer-modal__button-agree" onClick={this.props.onAgree}>I agree</Button>
          <Button className="disclaimer-modal__button-disagree" onClick={this.props.onDisagree}>I do not agree</Button>
        </div>
      </Modal>
    );
  }
}

DisclaimerModal.propTypes = {
  app: PropTypes.object.isRequired,
  onAgree: PropTypes.func.isRequired,
  onDisagree: PropTypes.func.isRequired,
  onModalClosed: PropTypes.func.isRequired
};

export default withAppContext(DisclaimerModal);
